import { render, staticRenderFns } from "./userDashboard.vue?vue&type=template&id=15736d24"
import script from "./userDashboard.vue?vue&type=script&lang=js"
export * from "./userDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports